<button color="primary" mat-icon-button [matMenuTriggerFor]="layerDropdown" matTooltip="Layer options"
  [disabled]="!node.layerAvailable">
  <mat-icon color="warn" >menu</mat-icon>
</button>
<mat-menu #layerDropdown >
  <div mat-menu-item *ngIf="node.trans" class="transparency" (click)="$event.stopPropagation();">
    <div class="label">Transparency</div>
    <mat-slider color="warn" (input)="updateOpacity($event)" [min]="0" [max]="1" [step]="0.1" [value]="transparency" [thumbLabel]="false" [tickInterval]="10"></mat-slider>
  </div>
  <button mat-menu-item (click)="ShowDescription()">
    Description
  </button>
  <button mat-menu-item *ngIf="node.label" (click)="labelLayer()" >
    Label
  </button>
  <a class="menu-link"  *ngIf="node.download" [href]="node.download" target="_blank" mat-menu-item (click)="gtag('download', node.name)">
    Download
  </a>
  <a class="menu-link" mat-menu-item *ngIf="node.metadata" [href]="node.metadata" target="_blank" (click)="gtag('metadata', node.name)">
    Metadata
  </a>
  <a class="menu-link"  mat-menu-item *ngIf="node.summaryReport" [href]="node.summaryReport" target="_blank" >
    Summary Report
  </a>
  <a class="menu-link"  *ngIf="node.hazusReport" [href]="node.hazusReport" target="_blank"  mat-menu-item>
    Hazus Report
  </a>
  <button mat-menu-item *ngIf="node.table && !node.rasterQuery" (click)="openAttributeTable()">
    Attribute table
  </button>
</mat-menu>

